import type { TWasmMapHover } from "../wasm";
import type CursorManager from "~/util/cursorManager";
import type Wasm from "../wasm";
import { createMarkerPopup } from "~/ui/map/markerpopup";
import { computePosition, shift, flip } from "@floating-ui/dom";
import { CONFIG } from "~/config";
import { description } from "~/util/providers/poiagg";
import { createMarkerInfo } from "~/ui/markerinfo";
import { nearestPointOnLine } from "@turf/nearest-point-on-line";
import { lineString, point } from "@turf/helpers";
import { cleanCoords } from "@turf/clean-coords";
import { length } from "@turf/length";
import { stringToCoords } from "~/util/mirek";
import { standardDistanceFormat } from "~/util/format";
import { createRouteSummaryPopup } from "~/ui/map/routesummarypopup";
import { iframeAnalyticsLog } from "~/util/analyticsAction";
import { store } from "~/state/store";
import { ROUTE_CONST } from "~/route/const";
import { openAdminDetail } from "~/util/userweb";
import { firmStats, isFirmFromPoi } from "~/util/review";
import { saveHistory } from "~/util/providers/history";

const SHOW_POPUP_DELAY = 300;
const HIDE_POPUP_DELAY = 200;
/** DOM element pouzivany pro popup nad markerem v mape */
const markerPopup = createMarkerPopup();
/** timeout pro zobrazeni popupu */
let popupShowTimeout: number = 0;
/** timeout pro schovani popupu */
let popupHideTimeout: number = 0;

function popupfirmStats(type, data, specParam) {
	switch (type) {
		case "route":
		case "detail":
			firmStats("firmy-vizitka-akce", data, specParam);
			break;
		case "desc":
			firmStats("firmy-vizitka-doruceni", data, specParam);
			break;
		default:
			//
	}
};

function setPopupContent(container: HTMLElement, poi, search: boolean) {
	const isDMorUM = Mapy.getComponent("distanceMeter").isActive() || Mapy.getComponent("userMarks").isActive() || poi.source === "gr";
	// obsah
	const markerInfo = createMarkerInfo({
		poi,
		routeBtnCb: async () => {
			//FIXME pokud je otevreny imageuploader ma to tak zustat
			if (Mapy.getComponent("imageUploader").isActive()) {
				return;
			}

			// eslint-disable-next-line @typescript-eslint/no-use-before-define
			hidePopup();

			if (CONFIG.inFrame) {
				iframeAnalyticsLog({
					type: "click-back",
					referrer: document.referrer,
					form: "other",
				});
				window.open(`${CONFIG.mapyURL}/${store.getState().map.mapset}?planovani-trasy&y=${poi.mark.lat}&x=${poi.mark.lon}&z=18&rc=${Scene.coordsToString([Scene.coordsFromWGS84(poi.mark.lon, poi.mark.lat)])}&rs=&rs=${poi.source}&ri=&ri=${poi.id}&mrp={"c"%3A111}`);
			} else {
				const route = Mapy.getComponent("route");

				if (!Mapy.CML.state.route?.items?.length) {
					Mapy.CML.state = {
						route: {
							params: {
								criterion: poi.source === "pubt" ? 200 : 111,
								type: poi.source === "pubt" ? ROUTE_CONST.TYPE_PUBT : ROUTE_CONST.TYPE_CAR,
							},
						},
					};
				}

				await route.addItem({
					source: poi.source,
					position: Mapy.getComponent("route").isActive() ? ROUTE_CONST.position.start : ROUTE_CONST.position.end,
					id: poi.id,
					name: poi.title,
					coords: Scene.coordsFromWGS84(poi.mark.lon, poi.mark.lat),
					desc: poi.multiTitle ? poi.multiTitle.slice(1).join(", ") : poi.title,
					..."typeId" in poi ? { typeId: poi.typeId } : {},
				});
			}

			if (isFirmFromPoi(poi)) {
				popupfirmStats("route", poi, { placeId: 9, typeId: 3 });
			}

			if (!CONFIG.inFrame) {
				Mapy.getComponent("history").save();
			}
		},
	});

	// click eventy
	// pro detail nechceme otevrit znovu detail
	if (!isDMorUM) {
		markerInfo.info.addEventListener("click", event => {
			//FIXME pokud je otevreny imageuploader ma to tak zustat
			if (Mapy.getComponent("imageUploader").isActive()) {
				return;
			}

			// eslint-disable-next-line @typescript-eslint/no-use-before-define
			hidePopup();

			if (CONFIG.inFrame) {
				iframeAnalyticsLog({
					type: "click-back",
					referrer: document.referrer,
					form: "other",
				});
				window.open(`${CONFIG.mapyURL}/${store.getState().map.mapset}?source=${poi.source}&id=${poi.id}`);
			} else if (store.getState().map.mapset === "uzavirky" && poi.past) { // klik na minule uzavirky otevre detail v poiadminu
				openAdminDetail(poi.source, poi.id);
			} else {
				const state = {
					source: poi.source,
					id: poi.id,
					manual: true,
					show: false,
					...Mapy.getComponent("search").isActive()
						? { search: Mapy.getComponent("detail").getSuggestConf() }
						: {},
				};

				if (search) {
					const filters = Mapy.getComponent("search").getFilters();
					const logObj = {
						/* eslint-disable camelcase */
						search_type: "searchmap",
						...Object.keys(filters).length
							? {
								filter_id: "",
								filter_type: "",
							}
							: {},
						/* eslint-enable camelcase */
					};

					if (Object.keys(filters).length) {
						for (const filterKey in filters) {
							if (Object.prototype.hasOwnProperty.call(filters, filterKey)) {
								/* eslint-disable camelcase */
								logObj.filter_id += (logObj.filter_id === "" ? "" : ",") + filters[filterKey].id;
								logObj.filter_type += (logObj.filter_type === "" ? "" : ",") + filters[filterKey].type;
								/* eslint-enable camelcase */
							}
						}
					}
					Mapy.Util.analyticsSearchSelection(logObj, poi);
				}

				if (!Mapy.Util.linkToNewWindow(event)) {
					event.preventDefault();

					Mapy.getComponent("detail").setState(state).then(() => {
						const { user } = store.getState().user;

						saveHistory(user, {
							title: poi.title,
							source: "web",
							type: "poi",
							data: {
								entitySource: poi.source,
								entityId: poi.id,
								lon: poi.mark.lon,
								lat: poi.mark.lat,
							},
						}).then(() => {}, () => {});
						Mapy.getComponent("history").save();
					}, () => {});

					if (Mapy.Util.isSmallResolution()) {
						Mapy.getComponent("layout").setWidth(1);
					}
				}
			}

			if (isFirmFromPoi(poi)) {
				popupfirmStats("detail", poi, { placeId: 9, typeId: 7 });
			}
		});
	}

	container.innerHTML = "";
	container.appendChild(markerInfo.info);

	if (!isDMorUM) {
		container.append(markerInfo.seperatorPart, markerInfo.buttonPart);
	}

	if (isFirmFromPoi(poi) && poi.paid) {
		popupfirmStats("desc", poi, { placeId: 9 });
	}
}

export function showPopup({ clientX, clientY, source, id, search }: { clientX: number, clientY: number, source: string, id: number, search: boolean }) {
	// pokud se melo ukazat neco jineho, tak ted uz ne
	popupShowTimeout && clearTimeout(popupShowTimeout);
	// pokud se melo schovavat, tak ted uz ne
	popupHideTimeout && clearTimeout(popupHideTimeout);
	popupHideTimeout = 0;
	// nastavime timeout na zobrazeni popupu
	popupShowTimeout = window.setTimeout(async () => {
		// pokud ve chvili zobrazeni mame neco schovat, tak to schovani zrusime
		popupHideTimeout && clearTimeout(popupHideTimeout);
		// vynulujeme si timeouty
		popupShowTimeout = 0;
		popupHideTimeout = 0;
		// skutecne ukazeme popup
		markerPopup.innerHTML = "";
		const descriptionResponse = await description([{ source, id }], {
			fetchPhoto: true,
			ratios: ["1x1"],
			lang: CONFIG.langPriority,
			query: Mapy.getComponent("search").getQuery(),
			reviews: true,
			wikimedia: true,
		});
		const poi = descriptionResponse.poi.length ? descriptionResponse.poi[0] : { source, id };
		const middleware = [
			flip({
				crossAxis: "alignment",
				fallbackAxisSideDirection: "end",
			}),
			shift({
				crossAxis: true,
			}),
		];

		setPopupContent(markerPopup, poi, search);
		document.body.appendChild(markerPopup);
		computePosition({
			getBoundingClientRect() {
				return {
					width: 0,
					height: 0,
					x: clientX,
					y: clientY,
					top: clientY,
					left: clientX,
					right: clientX,
					bottom: clientY,
				};
			},
		}, markerPopup, {
			placement: "bottom-start",
			middleware,
		}).then(({ x, y }) => {
			Object.assign(markerPopup.style, {
				left: `${x}px`,
				top: `${y}px`,
			});
		});
	}, SHOW_POPUP_DELAY);
}

export function hidePopup() {
	!popupHideTimeout && (popupHideTimeout = window.setTimeout(() => {
		// pokud se melo ukazat neco jineho, tak ted uz ne
		popupShowTimeout && clearTimeout(popupShowTimeout);
		// skutecne schovame popup
		markerPopup.remove();
	}, HIDE_POPUP_DELAY));
}

markerPopup.addEventListener("pointerenter", () => {
	popupHideTimeout && clearTimeout(popupHideTimeout);
	popupHideTimeout = 0;
});
markerPopup.addEventListener("pointerleave", () => {
	hidePopup();
});

/** reference na popup pro shrnuti trasy */
let summaryGeometryPopup: ReturnType<typeof createRouteSummaryPopup> = null;
/** reference na GEOJson linii */
let summaryGeometryLine: ReturnType<typeof lineString> = null;
/** celkova delka GEOJson geometrie */
let summaryGeometryTotalLength: number = 0;

export function setRouteSummaryPopup(strPoints: string, contactX: number, contactY: number, wasm: Wasm) {
	// pokud jeste neni vytvorena GEOJson geometrie, tak ji vyrobime
	if (!summaryGeometryLine) {
		summaryGeometryLine = cleanCoords(lineString(stringToCoords(strPoints)));
	}

	// pokud jeste neni spocitana delka GEOJson geometrie, tak ji spocitame
	if (!summaryGeometryTotalLength) {
		summaryGeometryTotalLength = length(summaryGeometryLine, { units: "meters" });
	}

	const contactPoint = wasm.coordsFromScreenPosition(contactX, contactY);
	const nearest = nearestPointOnLine(summaryGeometryLine, point([contactPoint.x, contactPoint.y]), { units: "meters" });

	if (!summaryGeometryPopup) {
		summaryGeometryPopup = createRouteSummaryPopup();
		document.body.appendChild(summaryGeometryPopup.container);
	}

	const fromObject = standardDistanceFormat(nearest.properties.location.toString());
	const toObject = standardDistanceFormat(((summaryGeometryTotalLength - nearest.properties.location)).toString());

	summaryGeometryPopup.fromStart.innerHTML = `<strong>${fromObject.distance}</strong>&nbsp;${fromObject.unit}`;
	summaryGeometryPopup.toFinish.innerHTML = `<strong>${toObject.distance}</strong>&nbsp;${toObject.unit}`;
	summaryGeometryPopup.container.style.setProperty("left", `${contactX}px`);
	summaryGeometryPopup.container.style.setProperty("bottom", `${window.innerHeight - contactY}px`);
}

export function unsetRouteSummaryPopup() {
	summaryGeometryPopup?.container.remove();
	summaryGeometryPopup = null;
	summaryGeometryLine = null;
	summaryGeometryTotalLength = 0;
}

/** reference na aktualni kurzor */
let hoverCursor: object = null;

export function useCursor(cursor: string, data: TWasmMapHover, cursorManager: CursorManager) {
	if (data.type === "enter") {
		if (hoverCursor) {
			cursorManager.update(hoverCursor, cursor);
		} else {
			hoverCursor = cursorManager.add(cursor);
		}
	} else if (data.type === "leave") {
		hoverCursor && cursorManager.remove(hoverCursor);
		hoverCursor = null;
	}
}
